(function($) {
  
  /* CALCULADORA SOLAR  */
  let user_data = [];
  let $form_calcular;
  let $form_orcamento;
  
  $('.solar-energy-simulation-form-data-type').on('click', function() {
    $('.solar-energy-simulation-form-data-type').removeClass('selected');
    $(this).addClass('selected');
    
    $('.solar-energy-simulation-form-data-type input').removeAttr('checked');
    $(this).find('input').attr('checked', 'checked');
  });
  
  if ($('.solar-energy-simulation').length) {
    let $formularios = $('.solar-energy-simulation').find('form');
    
    if ($formularios.length == 2) {
      
      $form_calcular = $formularios[0];
      let $form_calcular_id = getFormId($form_calcular);
      
      $form_orcamento = $formularios[1];
      let $form_orcamento_id = getFormId($form_orcamento);
      
      $($form_calcular).submit(function() {
        user_data['kwh'] = $($form_calcular).find('input[name=kwh]').val();
        user_data['nome'] = $($form_calcular).find('input[name=nome]').val();
        user_data['telefone'] = $($form_calcular).find('input[name=tel]').val();
        user_data['email'] = $($form_calcular).find('input[name=email]').val();
        user_data['estado'] = $($form_calcular).find('select[name=estado]').val();
        user_data['cidade'] = $($form_calcular).find('select[name=cidade]').val();
        user_data['tipo'] = $($form_calcular).find('input[name=tipo]:checked').val();
        user_data['telhado'] = $($form_calcular).find('select[name=telhado]').val();
        
      });
      
      document.addEventListener( 'wpcf7mailsent', function( event ) {
        if ( $form_calcular_id == event.detail.contactFormId ) { 
          
          $($form_calcular).find('.ajax-loader').addClass('active');
          
          $.ajax({
          method: "POST",
          url: location.origin + '/perfect/wp-admin/admin-ajax.php',
          data: {
            action: 'gcs_recebe_dados_usuario',
            kwh: user_data['kwh'],
          },
          }).done(function(retorno) {
            $($form_calcular).find('.ajax-loader').removeClass('active');
            
            if (retorno) {
              
                retorno = JSON.parse(retorno);
                calcApresentarResultado(retorno, user_data);
                
            }
          });
        } 
      });
    } 
  }

    $('#voltar').on('click', function() {
        calcApresentarCalc();
    });
    
    function getFormId($form) {
      action = $($form).attr('action');
      id = action.replace(/[\s\S]+?\#wpcf7-f/gi,'').replace(/-+[a-zA-Z]+[0-9]/gi, '');
      return id;
    }
    
    
    function calcApresentarResultado(retorno, user_data) {
      $('#calculadora-solar').toggleClass('show-return');
      
      $($form_orcamento).find('input[name="nome"]').val(user_data['nome']);
      $($form_orcamento).find('input[name="email"]').val(user_data['email']);
      $($form_orcamento).find('input[name="telefone"]').val(user_data['telefone']);
      $($form_orcamento).find('input[name="estado"]').val(user_data['estado']);
      $($form_orcamento).find('input[name="cidade"]').val(user_data['cidade']);
      $($form_orcamento).find('input[name="tipo"]').val(user_data['tipo']);
      $($form_orcamento).find('input[name="telhado"]').val(user_data['telhado']);
      
      $($form_orcamento).find('input[name="kwh"]').val(retorno['kwh']);
      $($form_orcamento).find('input[name="quantidade-modulo"]').val(retorno['quantidade_modulo']);
      $($form_orcamento).find('input[name="potencia-modulo"]').val(retorno['potencia_modulo']);
      $($form_orcamento).find('input[name="potencia-total"]').val(retorno['potencia_total']);
      $($form_orcamento).find('input[name="producao-mensal"]').val(retorno['producao_mensal']);
      $($form_orcamento).find('input[name="area-aproximada"]').val(retorno['area_aproximada']);
      
      $('#return-kwh').html(retorno['kwh'] + 'kWh');
      $('#return-quantidade-modulo').html(retorno['quantidade_modulo'] + '');
      $('#return-potencia-modulo').html(retorno['potencia_modulo'] + 'W');
      $('#return-potencia-total').html(retorno['potencia_total'] + ' kWp');
      $('#return-producao-mensal').html(retorno['producao_mensal'] + ' kWh');
      $('#return-area-aproximada').html(retorno['area_aproximada'] + 'm²');
    }
    
    function calcApresentarCalc() {
        $('#calculadora-solar').toggleClass('show-return');
    }
    
    /*  SOLICITAÇÃO DE RETIRADA DO RANGE DA CALCULADORA SOLAR 06/07/2021 POR ESTEFANY VIA WHATSAPP
    
    --------------- CÓDIGO DO CONTACT FORM ------------------
    <div class="solar-energy-simulation-form-data">
        <label class="solar-energy-simulation-form-data-label" for="">Qual o consumo de KW/Mês?</label>
        <p class="solar-energy-simulation-form-data-label-description">Mova a barra correspondendo ao valor</p>
        <div class="solar-energy-simulation-form-data-kwh-container">
            <div class="solar-energy-simulation-form-data-kwh-range-container">
                <div class="solar-energy-simulation-form-data-kwh-small-container">
                    <div class="solar-energy-simulation-form-data-kwh-small"></div>  
                </div>
                <div class="solar-energy-simulation-form-data-kwh-input-range-container">

[range kwh min:100 max:10000 class:solar-energy-simulation-form-data-kwh-range]

                </div>
                <div class="solar-energy-simulation-form-data-kwh-big-container">
                    <div class="solar-energy-simulation-form-data-kwh-big"></div>
                </div>
            </div>
        </div>
    </div>
    -----------------------------------------------------------
    
    
    
    // RANGESLIDER - https://codepen.io/mukealicious/pen/jWoeZY 

    const $rangeslider = $('.solar-energy-simulation-form-data-kwh-range');
    var $handle;
  
    $rangeslider
    .rangeslider({
      polyfill: false,
      onInit: function() {
        $handle = $('.rangeslider__handle', this.$range);
        $('.rangeslider__handle').html('<input class="rangeslider__handle__number" type="number" value="5000" min="100" max="10000" name="kwh"/>kWh')
      }
    })
    .on('input', function() {
        updateHandle($handle[0], this.value);
        numberFocus();
    });
    
    // CALCULADORA SOLAR - Fazer range se movimentar conforme números digitados 
    
    // Update the value inside the slider handle
    function updateHandle(el, val) {
        $rangeslider.attr('min', '0');
        el.textContent = '';
        $('.rangeslider__handle').html('<input class="rangeslider__handle__number" type="number" value="'+val+'" min="100" max="10000" name="kwh"/>kWh');
        
        $('.rangeslider__handle__number').on('input', function() {
            if ($(this).val() >= 100) {
              $rangeslider.val($('.rangeslider__handle__number').val()).change();
            }
        });
    }
    
    $('.rangeslider__handle__number').on('click', function() {
      $rangeslider.val($('.rangeslider__handle__number').val()).change();
    });
        
    $('.rangeslider__handle__number').on('mousedown', numberSelect);
    
    $('.rangeslider__handle').on('touchend', numberSelect);
    
    function numberSelect() {
      
      $('.rangeslider__handle__number').select();
    }
    
    function numberFocus() {
      $('.rangeslider__handle__number').focus();
      let value = $('.rangeslider__handle__number').val();
      $('.rangeslider__handle__number').val('');
      $('.rangeslider__handle__number').val(value);
    }
    
    function validationFunction() {
      if($('.solar-energy-simulation').hasClass('show-return')) {
        return true;
      }
      return false;
    }
    
    if ($('#calculadora-solar').length) {
        $(document).ready(function() {
          $(window).keydown(function(event){
            if( (event.keyCode == 13) && (validationFunction() == false) ) {
              event.preventDefault();
              return false;
            }
          });
        });
    }*/
    
})(jQuery);